import {
  CreatePaypalOrder,
  CapturePaypalOrder,
  CreatePaypalPaymentOrder,
  CapturePaypalPaymentOrder,
  getStudentPaymentMethods,
} from "../../DriveScout/API/models/OrdersModel";
import { GetCustomerSources } from "../../DriveScout/API/models/CustomerSourceModel";

const state = {};

const mutations = {};

const actions = {
  /**
   * Create a new DriveScout order paid through PayPal
   * @param {Object} data - the order body, its request_id included (common/payments/PaymentRequest)
   */
  CREATE_PAYPAL_ORDER({ commit }, data) {
    return CreatePaypalOrder(data).then((response) => {
      return response.data;
    });
  },
  CAPTURE_PAYPAL_ORDER({ commit }, data) {
    return CapturePaypalOrder(data).then((response) => {
      return response.data;
    });
  },
  /**
   * Create a PayPal order for making a payment on an existing DriveScout order
   * @param {Object} data - { order_id: number, payment_amount: number, request_id: string }
   *   request_id is the approval's idempotency key (common/payments/PaymentRequest)
   */
  CREATE_PAYPAL_PAYMENT_ORDER({ commit }, data) {
    return CreatePaypalPaymentOrder(data).then((response) => {
      return response.data;
    });
  },
  /**
   * Capture a PayPal payment for an existing order
   * @param {Object} data - { order_id: number, paypal_order_id: string }
   */
  CAPTURE_PAYPAL_PAYMENT_ORDER({ commit }, data) {
    return CapturePaypalPaymentOrder(data).then((response) => {
      return response.data;
    });
  },
  GET_CUSTOMER_SOURCES({ commit }) {
    return GetCustomerSources().then((response) => {
      return response.data;
    });
  },
  GET_STUDENT_PAYMENT_METHODS({ commit }, student_id) {
    return getStudentPaymentMethods(student_id).then((response) => {
      return response.data.payment_methods;
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

